import styled, { createGlobalStyle } from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	background-color: var(--white);
	justify-content: space-between
`

export default createGlobalStyle`
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
	
	html, body, #root {
		max-width: 100vw;
		min-height: 100vh;
		width: 100%;

		display: flex;
		font-family: sans-serif;
	}

	.MuiPickersToolbar-toolbar, .MuiPickersDay-daySelected  {
    background-color: var(--primary) !important;
  }

	.MuiButton-outlined {
		border: 1px solid var(--primary) !important;
		color: var(--primary) !important;
	}

	.MuiPickersDay-daySelected {
		color: var(--white) !important;
	}

	/* .MuiTable-root {
		width: 100.1% !important;
		height: 100.1% !important;
	} */
	:root {
		--primary: #004F9F;
		--white: #FFF;
		--black: #000;
		--grey: #E2E2E2;
		--dark-gray: #606060;
		--light-gray: #B8B8B8;
	}
`